import { Box, List, ListItemButton, ListItemText, Typography, useTheme } from '@mui/material';
import React from 'react';

export interface AddFilterCategoriesProps {
  categories: Array<{ name: string; count: number }>;
  active: string;
  onSelect: (cat: string) => void;
}

export const AddFilterCategories: React.FC<AddFilterCategoriesProps> = ({
  categories,
  active,
  onSelect,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: 160,
        borderRight: `1px solid ${theme.palette.v4.border}`,
        overflowY: 'auto',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          px: 2,
          pt: 2,
          pb: 1,
          display: 'block',
          fontWeight: 600,
          textTransform: 'uppercase',
          color: theme.palette.text.secondary,
          letterSpacing: '0.05em',
        }}
      >
        Categories
      </Typography>

      <List dense disablePadding>
        {categories.map((cat) => {
          const isActive = cat.name === active;
          return (
            <ListItemButton
              key={cat.name}
              selected={isActive}
              onClick={() => onSelect(cat.name)}
              sx={{
                py: 0.75,
                px: 2,
                borderLeft: isActive
                  ? `3px solid ${theme.palette.v4.accent}`
                  : '3px solid transparent',
                '&.Mui-selected': {
                  bgcolor: 'transparent',
                  '&:hover': { bgcolor: theme.palette.action.hover },
                },
              }}
            >
              <ListItemText
                primary={cat.name}
                slotProps={{ primary: {
                  variant: 'body2',
                  fontWeight: isActive ? 600 : 400,
                  noWrap: true,
                } }}
              />
              <Typography
                variant="caption"
                sx={{ color: theme.palette.text.secondary, ml: 0.5 }}
              >
                {cat.count}
              </Typography>
            </ListItemButton>
          );
        })}
      </List>
    </Box>
  );
};
